import { Pipe, PipeTransform } from '@angular/core';
import { IShopOrderItem } from '@x/ecommerce/shop-client';

@Pipe({
  name: 'orderItemName',
  standalone: true,
})
export class OrderItemNamePipe implements PipeTransform {
  transform(item: IShopOrderItem): string {
    const { productName, variantName } = item;
    let name = productName;

    if (variantName) {
      name = `${productName} - ${variantName}`;
    }
    return name;
  }
}
